import { Star } from "lucide-react";
import { rating, ui } from "@/content";

export default function RatingBadge({ className = "" }) {
  return (
    <a
      href={rating.url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="rating-badge"
      className={`group inline-flex items-center gap-4 rounded-2xl bg-white/80 px-5 py-3 ring-1 ring-line transition-shadow hover:shadow-md ${className}`}
    >
      <span className="font-serif text-4xl leading-none text-forest" data-testid="rating-value">{rating.value}</span>
      <span className="flex flex-col">
        <span className="flex gap-0.5" aria-label={`${rating.value} av ${rating.scale}`}>
          {Array.from({ length: 5 }).map((_, i) => (
            <Star key={i} className="h-4 w-4 fill-amber text-amber" aria-hidden="true" />
          ))}
        </span>
        <span className="mt-1 text-sm font-medium text-ink" data-testid="rating-count">
          av {rating.scale} · {ui.ratingOf(rating.count)}
        </span>
        <span className="text-xs text-muted">{ui.verified(rating.verifiedLabel)}</span>
      </span>
    </a>
  );
}
